import { useLayoutEffect, useRef } from "react";
import { get, useFormState } from "react-hook-form";

/**
 * Calls `reveal` after each submit, and each new `attempt`, that leaves an
 * error under `name`, so a collapsed section opens before focus moves to the
 * error inside it. `attempt` is for validation run outside a submit.
 */
export const useRevealOnFailedSubmit = (
	name: string,
	reveal: () => void,
	attempt = 0
) => {
	const { submitCount, errors } = useFormState({ name });
	const handled = useRef({ submitCount, attempt });

	// A layout effect, so the section has rendered before `FormContainer` focuses.
	useLayoutEffect(() => {
		if (
			submitCount === handled.current.submitCount &&
			attempt === handled.current.attempt
		) {
			return;
		}
		handled.current = { submitCount, attempt };

		if (get(errors, name)) reveal();
	}, [submitCount, attempt, errors, name, reveal]);
};
